import classes from "./Accessibility.module.css";
import { Link } from "react-router-dom";

const AccessibilityEn = () => {
  return (
    <div className={`${classes.privacy}`}>
      <div>
        <h2>ΤΜΗΜΑ 1 </h2>
        <h3>ΔΗΛΩΣΗ ΠΡΟΣΒΑΣΙΜΟΤΗΤΑΣ</h3>
        <p>
          Ο <b>ΔΗΜΟΣ ΠΑΡΓΑΣ</b> δεσμεύεται να καθιστά τον οικείο ιστότοπο:{" "}
          <i>
            <a
              href="https://sensors.patras.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://sensors.patras.gr{" "}
            </a>
          </i>{" "}
          προσβάσιμο, σύμφωνα με τις προβλέψεις του ν. 4727/2020 (ΦΕΚ 184 Α’
          23-09-2020), Κεφάλαιο Η’ «ΨΗΦΙΑΚΗ ΠΡΟΣΒΑΣΙΜΟΤΗΤΑ (ΕΝΣΩΜΑΤΩΣΗ ΣΤΗΝ
          ΕΛΛΗΝΙΚΗ ΝΟΜΟΘΕΣΙΑ ΤΗΣ ΟΔΗΓΙΑΣ (ΕΕ) 2016/2102 ΤΟΥ ΕΥΡΩΠΑΪΚΟΥ
          ΚΟΙΝΟΒΟΥΛΙΟΥ ΚΑΙ ΤΟΥ ΣΥΜΒΟΥΛΙΟΥ, ΤΗΣ 26ΗΣ ΟΚΤΩΒΡΙΟΥ 2016, ΓΙΑ ΤΗΝ
          ΠΡΟΣΒΑΣΙΜΟΤΗΤΑ ΤΩΝ ΙΣΤΟΤΟΠΩΝ ΚΑΙ ΤΩΝ ΕΦΑΡΜΟΓΩΝ ΓΙΑ ΦΟΡΗΤΕΣ ΣΥΣΚΕΥΕΣ
          ΤΩΝ ΟΡΓΑΝΙΣΜΩΝ ΤΟΥ ΔΗΜΟΣΙΟΥ ΤΟΜΕΑ)» που ενσωματώνει στην εθνική έννομη
          τάξη την Οδηγία (ΕΕ) 2016/2012.
        </p>
        <p>
          Η παρούσα δήλωση προσβασιμότητας εφαρμόζεται στα εξής: στον ιστότοπο{" "}
          <i>
            <a
              href="https://sensors.patras.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://sensors.patras.gr/
            </a>
          </i>
        </p>

        <h4>Κατάσταση συμμόρφωσης</h4>
        <p>
          Ο παρών ιστότοπος{" "}
          <i>
            <a
              href="https://sensors.patras.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://sensors.patras.gr/
            </a>
          </i>{" "}
          συνάδει πλήρως με τις Οδηγίες για την προσβασιμότητα στο περιεχόμενο
          Ιστού (WCAG 2.1 ΑΑ).
        </p>
        <h4>Κατάρτιση της παρούσας δήλωσης προσβασιμότητας</h4>
        <p>Η παρούσα δήλωση καταρτίστηκε την 21-11-2022.</p>
        <p>
          Η πραγματική αξιολόγηση της συμμόρφωσης του ιστοτόπου προς τις
          απαιτήσεις της Οδηγίας (ΕΕ) 2016/2102 πραγματοποιήθηκε με
          αυτοαξιολόγηση διενεργηθείσα από τον οργανισμό του δημόσιου τομέα και
          με την χρήση του UserWay Website Accessibility Widget
        </p>
        <p>Τελευταία αναθεώρηση της δήλωσης στις 21-11-2022.</p>

        <h4>Υποβολή παρατηρήσεων και στοιχεία επικοινωνίας</h4>
        <p>
          Σύμφωνα με τις προβλέψεις του ν. 4727/2020 (ΦΕΚ 184 Α’ 23-09-2020),
          άρθρο 45, κάθε ενδιαφερόμενος έχει δικαίωμα να υποβάλλει παρατηρήσεις
          ή αίτηση για ενημέρωση ως προς την κατάσταση συμμόρφωσης ή αίτηση για
          πληροφορίες που ελλείπουν.
        </p>
        <p>
          Στο <b>ΔΗΜΟ ΠΑΡΓΑΣ</b> τα ανωτέρω υποβάλλονται με σχετική Αίτηση του
          ενδιαφερομένου η οποία υποβάλλεται μέσω του email στο
          protodp@patras.gr
        </p>
        <p>
          Αρμόδια Υπηρεσία για θέματα προσβασιμότητας και για τη διεκπεραίωση
          αιτημάτων που υποβάλλονται μέσω του μηχανισμού υποβολής παρατηρήσεων
        </p>
        <h4>Διεύθυνση Προγραμματισμού, Οργάνωσης και Πληροφορικής</h4>
        <p>
          e-mail:{" "}
          <a
            href="mailto:pliroforiki@patras.gr "
            target="_blank"
            rel="noreferrer"
          >
            pliroforiki@patras.gr{" "}
          </a>
        </p>
        <h4>Διαδικασία εκτέλεσης</h4>
        <p>
          Η αρμόδια διεύθυνση του <b>ΔΗΜΟΥ ΠΑΡΓΑΣ</b> απαντά στον ενδιαφερόμενο
          με πρόσφορο τρόπο.
        </p>
        <p>
          Σε περίπτωσης μη ικανοποιητικής απάντησης στην ενημέρωση ή στα
          αιτήματα ο ενδιαφερόμενος δικαιούται να αποταθεί σύμφωνα με την
          πρόβλεψη στις αρμόδιες θεσμικές αρχές, όπως με την υποβολή σχετικής
          Αναφοράς στον Συνήγορο του Πολίτη (https://www.synigoros.gr).
        </p>
        <h2>ΤΜΗΜΑ 2</h2>
        <h3>Ενεργοποίηση του Μενού Προσβασιμότητας</h3>
        <p>
          Το μενού προσβασιμότητας του ιστοτόπου{" "}
          <i>https://sensors.patras.gr</i> μπορεί να ενεργοποιηθεί κάνοντας κλικ
          στο εικονίδιο του μενού προσβασιμότητας που εμφανίζεται στο πάνω μέρος
          της σελίδας. Αφού ενεργοποιήσετε το μενού προσβασιμότητας, περιμένετε
          λίγο για να φορτωθεί το μενού προσβασιμότητας στο σύνολό του.
        </p>
        <p>
          Το <i>https://sensors.patras.gr</i> συνεχίζει τις προσπάθειές του για
          να βελτιώνει συνεχώς την προσβασιμότητα του ιστότοπου με την πεποίθηση
          ότι είναι η συλλογική ηθική μας υποχρέωση να επιτρέπουμε την
          απρόσκοπτη, προσβάσιμη και απρόσκοπτη χρήση και για όσους από εμάς
          έχουν αναπηρία.
        </p>
        <p>
          Σε μια συνεχή προσπάθεια για συνεχή βελτίωση και αποκατάσταση
          προβλημάτων προσβασιμότητας, σαρώνουμε τακτικά το{" "}
          <i>https://sensors.patras.gr</i> με το σαρωτή προσβασιμότητας του
          UserWay για να εντοπίσουμε και να διορθώσουμε κάθε πιθανό εμπόδιο
          προσβασιμότητας στον ιστότοπο. Παρά τις προσπάθειές μας να κάνουμε
          όλες τις σελίδες και το περιεχόμενο στο https://sensors.patras.gr/
          πλήρως προσβάσιμο, κάποιο περιεχόμενο ενδέχεται να μην έχει ακόμη
          προσαρμοστεί πλήρως στα αυστηρότερα πρότυπα προσβασιμότητας.
        </p>

        <p style={{ float: "right", fontWeight: 600, marginTop: 20 }}>
          <Link to={"/"}>Επιστροφή στην Αρχική</Link>
        </p>
      </div>
    </div>
  );
};

export default AccessibilityEn;
